import { useState, useCallback } from 'react'
import { PAGINATION } from '@/shared/lib/constants'

export interface UsePaginationProps {
  initialPage?: number
  initialLimit?: number
}

export interface UsePaginationReturn {
  page: number
  limit: number
  setPage: (page: number) => void
  setLimit: (limit: number) => void
  reset: () => void
  getOffset: () => number
}

export function usePagination({
  initialPage = PAGINATION.DEFAULT_PAGE,
  initialLimit = PAGINATION.DEFAULT_LIMIT,
}: UsePaginationProps = {}): UsePaginationReturn {
  const [page, setPageState] = useState(initialPage)
  const [limit, setLimitState] = useState(initialLimit)

  const setPage = useCallback((newPage: number) => {
    setPageState(Math.max(1, newPage))
  }, [])

  const setLimit = useCallback((newLimit: number) => {
    setLimitState(Math.max(1, newLimit))
    setPageState(1) // Сбрасываем на первую страницу при изменении лимита
  }, [])

  const reset = useCallback(() => {
    setPageState(initialPage)
    setLimitState(initialLimit)
  }, [initialPage, initialLimit])

  const getOffset = useCallback(() => {
    return (page - 1) * limit
  }, [page, limit])

  return {
    page,
    limit,
    setPage,
    setLimit,
    reset,
    getOffset,
  }
}
